import styled from "styled-components"
import ProTableOt from "./../../../utility/componentOt/views/ProtableOt"
import { useTranslation } from "react-i18next";
import { useBib } from "../../controllers/BibController";
import { Row, Col, Button, setParamsFilter, toast, Typography, message, Input, Alert, Popconfirm, Tag } from '../../../ui/ot'
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import dayjs from 'dayjs';
import { useCRUDController } from "../../../ui/classify_structure/CRUDController";
import BookImages from "../../components/book_images";
const ManageMARCRecord = ({
    title,
    keyPrefix = 'library.manage_marc_record',
    permission_level = null,
}) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.manage_marc_record"

    return (<Row>
        <Col span={24}>
            <Title>
                {title || t(`${i18nPrefix}.manage_marc_record`)}
            </Title>
        </Col>
        <Col span={24}>
            <ManageMARCRecordTable title={title} keyPrefix={keyPrefix} selectType="checkbox" permission_level={permission_level} />
        </Col>
    </Row>)
}
const ManageMARCRecordTable = ({
    title,
    mode = "search",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    selectType = "radio",
    readonly,
    permission_level = null,
}) => {
    const thisJS = "ManageMARCRecord"
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.manage_marc_record"
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [search, setSearch] = useState({
        datecreated_start: dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
        datecreated_end: dayjs().format('YYYY-MM-DD'),
    })

    const navigate = useNavigate()
    const actionRef = useRef()
    const columns = [
        {
            title: t(`${i18nPrefix}.results`),
            dataIndex: 'bib_biblionumber',
            key: 'bib_biblionumber',
            sorter: true,
            // width: '50rem',
            render: (text, record, index) => {
                let fileId = !!record?.bib_cover_images ? record?.bib_cover_images : []
                let file_id = (fileId || [])?.map((val) => {
                    return {
                        file_id: val
                    }
                })
                if (file_id.length === 0) {
                    file_id = [
                        {
                            src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + record?.bibitem_isbn
                        },
                    ]
                }
                return <Col span={24}>
                    <Row gutter={[8, 8]}>
                        <Col xxl={4} xl={3} lg={4} md={24} sm={24} xs={20}>
                            <Row justify="center" >
                                <Col xxl={24} xl={24} lg={24} md={8} sm={8} xs={24}  >
                                    <BookImages
                                        bookImageData={file_id}
                                        biblionumber={record?.bib_biblionumber}
                                        title={record?.bib_title}
                                        isbn={record?.bibitem_isbn}
                                        onChanged={() => actionRef.current?.reload()}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={16} xl={18} lg={20} md={24} sm={24} xs={24}>
                            <Row>
                                {
                                    getBibInfoFormat().map((value) => {
                                        if (value?.language_name === "bib_title") {
                                            return <>
                                                <Col span={24}>
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0} >{(index + 1)}.<Link to={`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`} style={{ color: 'blue', fontWeight: 'bold' }}>{value?.valueKeys.map((keysValue) => record?.[keysValue])}</Link></Typography.P>
                                                </Col>
                                                <Col span={24}>
                                                    <Row gutter={[4, 4]}>
                                                        <Col>
                                                            館藏資訊：{record?.authorised.length === 0 && <>無館藏</>}
                                                        </Col>
                                                        {record?.authorised?.map((val) => {
                                                            if (val?.name === "可借閱") {
                                                                return <Col><Tag color="success" >
                                                                    {val?.name}:{val?.count}本
                                                                </Tag> </Col>
                                                            }
                                                            else {
                                                                return <Col><Tag >
                                                                    {val?.name}:{val?.count}本
                                                                </Tag> </Col>
                                                            }
                                                        })}
                                                    </Row>
                                                </Col>
                                            </>
                                        }
                                        else if (value?.language_name === "Language") {
                                            return <Col xxl={4} xl={12} >
                                                <Typography.P style={{ marginBottom: 0 }} mt={0}>{t(`${i18nPrefix}.${value?.language_name}`)}：{value?.valueKeys.map((keysValue) => record?.[keysValue]?.['Language'])} </Typography.P>
                                            </Col>
                                        }
                                        else if (value?.language_name === "online_resources") {
                                            let bib_electronic_location = record?.bib_electronic_location
                                            let bib_electronic_location_name = record?.bib_electronic_location_name
                                            return (
                                                <Col xxl={4} xl={12} >
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0}>{t(`${i18nPrefix}.${value?.language_name}`)}：{value?.valueKeys.map((keysValue) => record?.[keysValue]?.['Language'])}
                                                        {bib_electronic_location && <Button
                                                            type="link"
                                                            onClick={() => {
                                                                window.open(bib_electronic_location, 'blank')
                                                            }}
                                                        >{bib_electronic_location_name}</Button>}
                                                    </Typography.P>

                                                </Col>
                                            )
                                        }
                                        else {
                                            let span = value?.language_name === "Description" || value?.language_name === "Other_title" || value?.language_name === "Publication_details" ?
                                                {
                                                    xxl: 24,
                                                    xl: 24,
                                                    lg: 24,
                                                    md: 24,
                                                    sm: 24,
                                                    xs: 24

                                                } :
                                                {
                                                    xxl: 12,
                                                    xl: 12,
                                                    lg: 12,
                                                    md: 12,
                                                    sm: 12,
                                                    xs: 24
                                                }

                                            return <Col {...span}>
                                                <Typography.P style={{ marginBottom: 0 }} mt={0}>{t(`${i18nPrefix}.${value?.language_name}`)}：{value?.valueKeys.map((keysValue) => {
                                                    if (value?.isJoin) {
                                                        return record?.[keysValue].join('、')
                                                    }
                                                    else {
                                                        return record?.[keysValue]
                                                    }
                                                })}</Typography.P>
                                            </Col>
                                        }

                                    })
                                }

                            </Row>
                        </Col>
                        <Col xxl={3} xl={3} lg={24} md={24} sm={24} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Row justify={'end'} gutter={[8, 8]}>
                                        <Col xxl={24} xl={24} lg={6} md={6} sm={6} xs={12} >
                                            <Button
                                                block={true}
                                                type='default'
                                                size="small"
                                                disabled={true}
                                            >
                                                {record?.items_count > 0 ? t(`${i18nPrefix}.borrowed`) + "(" + (record?.items_borrowed_count || 0) + ")" : t(`${i18nPrefix}.No_items`)}
                                            </Button>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={6} md={6} sm={6} xs={12} >
                                            <Button
                                                block={true}
                                                type='default'
                                                size="small"
                                                onClick={() => {
                                                    window.open(`/library/backstage/EditMARC?bib_biblionumber=${record?.bib_biblionumber}`)
                                                }}
                                            >
                                                {t('library.backstage.EditMARC.')}
                                            </Button>
                                            {/* <Link target="_blank" to={`/library/backstage/EditMARC?bib_biblionumber=${record?.bib_biblionumber}`}>{t('library.backstage.EditMARC.')}</Link> */}
                                        </Col>
                                        <Col xxl={24} xl={24} lg={6} md={6} sm={6} xs={12} v>
                                            <Popconfirm
                                                title="刪除項目"
                                                description="確定刪除該項目?"
                                                onConfirm={() => {
                                                    BibController.deleteData([{ biblionumber: record?.bib_biblionumber }])
                                                }}
                                            >
                                                <Button
                                                    block={true}
                                                    type='default'
                                                    size="small"
                                                >
                                                    {t('library.backstage.DeleteMARC.')}
                                                </Button>
                                            </Popconfirm>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={6} md={6} sm={6} xs={12} >
                                            <Button
                                                block={true}
                                                type='default'
                                                size="small"
                                                onClick={() => {
                                                    window.open(`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`)
                                                }}
                                            >
                                                館藏維護
                                                {/* {t('library.backstage.BookDetail.')} */}
                                            </Button>
                                            {/* <Link target="_blank" style={{ color: "#FD7E14" }} to={`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`}>{t('library.backstage.BookDetail.')}</Link> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            }
        },
        // {
        //     title: t(`${i18nPrefix}.location`),
        //     dataIndex: 'items_count',
        //     key: 'items_count',
        //     align: "end",
        //     render: (text, record, index) => {
        //         if (!record.items_count) {
        //             return <>
        //                 {t(`${i18nPrefix}.No_items`)}
        //             </>
        //         } else {
        //             return <>
        //                 <Typography.P>{record?.items_count}{t(`${i18nPrefix}.item`)}, {record?.items_count - record?.items_borrowed_count}{t(`${i18nPrefix}.available`)}</Typography.P>
        //             </>
        //         }
        //     }
        // },
    ]
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.bib_biblionumber)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.bib_biblionumber);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record?.bib_biblionumber)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record?.bib_biblionumber)
                selectRow = selectRow.filter(row => row?.bib_biblionumber !== record?.bib_biblionumber)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const {
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "getBibData OnFinish", axiosMode, status, values)
            if (axiosMode === "delete") {
                if (status === "success") {
                    toast.success(t("delete") + " " + t("success"))
                }
                else {
                    toast.error(t("delete") + " " + t("failed"))
                }
                actionRef.current.reload()
            }
        },
        onBefore: () => { }
    })
    const BibController = useCRUDController({
        apiRoute: "/koha/bib",
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "deleteBibData OnFinish", axiosMode, status, values)
            if (axiosMode === "delete") {
                if (status === "success") {
                    message.success(t("delete") + t("success"))
                }
                else {
                    console.log({ values })
                    message.error(t("delete") + t("failed") + "請檢查是否有館藏項目")
                }
                actionRef.current.reload()
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
        },
        onBefore: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (
        <Row gutter={[4, 4]}>
            <Col lg={24} md={24} sm={24} xs={24}>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 px-3 sm:px-4 py-2">
                    <div className="flex items-center gap-2">
                        <div className="text-xs sm:text-sm font-medium text-yellow-800">注意</div>
                        <div className="text-xs sm:text-sm text-yellow-700">不輸入日期區間，請輸入關鍵字</div>
                    </div>
                </div>
            </Col>
            <Col span={24}>
                <ProTableOt
                    headerTitle={<Row gutter={[4, 4]} align={"middle"}>
                        <Col>
                            <Typography.P style={{ marginBottom: 0 }}>
                                {t(`${i18nPrefix}.import_bibliography_date`)}:
                            </Typography.P>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                // granularity={"day"}
                                // placeholder={t(`${i18nPrefix}.time_start`)}
                                format={"YYYY-MM-DD"}
                                value={search?.datecreated_start ? search?.datecreated_start : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if (dayjs(e.target.value).isBefore(dayjs(pre?.datecreated_end, "YYYY-MM-DD"))) {
                                            return {
                                                ...pre,
                                                datecreated_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                datecreated_start: pre?.datecreated_end,
                                                datecreated_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4}>
                                ~
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                placeholder={t(`${i18nPrefix}.time_end`)}
                                format={"YYYY-MM-DD"}
                                value={search?.datecreated_end ? search?.datecreated_end : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if ((dayjs(e.target.value)).isBefore(pre?.datecreated_start)) {
                                            return {
                                                ...pre,
                                                datecreated_start: e.target.value,
                                                datecreated_end: pre?.datecreated_start,
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                datecreated_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        {(search?.datecreated_start || search?.datecreated_end) &&
                            <Col>
                                <Button
                                    type={"icon"}
                                    onClick={() => {
                                        setSearch((pre) => {
                                            return {
                                                datecreated_start: undefined,
                                                datecreated_end: undefined
                                            }
                                        })
                                    }}>
                                    X
                                </Button>
                            </Col>
                        }
                    </Row>}
                    rowKey={"bib_biblionumber"}
                    searchParams={search}
                    actionRef={actionRef}
                    columns={columns}
                    extraActionRenderShow={false}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                            ...search,
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            // custom_filter_value: params.keyword ?? "",
                            // keyword: params.keyword ?? "",
                            search: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            "field": !!params.keyword ? "keyword" : "",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        if (!newParams?.datecreated_start && !newParams?.datecreated_end && !newParams?.search) {
                            message.warning("請至少輸入一項篩選條件")
                        }
                        return getBibData({
                            ...newParams
                        })
                    }}
                    scroll={{
                        x: undefined,
                        y: undefined,
                    }}
                    toolBarPosition="search"
                    toolBarRender={() => {
                        return (permission_level === 1 ? [
                            <Button variant="outline" style={{ color: "#007BFF" }}
                                onClick={() => { window.open("/library/backstage/SearchZ3950", "_blank") }}>
                                {t('library.backstage.SearchZ3950.')}
                            </Button>,
                            <Button variant="outline" style={{ color: "#FD7E14" }}
                                onClick={() => { window.open("/library/backstage/StageMARCRecord", "_blank") }}>
                                {t('library.cataloging.import_bib')}
                            </Button>,
                            <Button variant="outline" style={{ color: "#28a745" }}
                                onClick={() => { window.open("/library/backstage/AddMARC", "_blank") }}>
                                {t('library.backstage.AddMARC.')}
                            </Button>,
                            selectedRowKeys.length > 0 && <Popconfirm
                                title="刪除項目"
                                description="確定刪除勾選項目?"
                                onConfirm={() => {
                                    let data = selectedRowKeys.map((val) => {
                                        return {
                                            biblionumber: val
                                        }
                                    })
                                    BibController.deleteData(data)
                                }}
                            >
                                <Button
                                    variant="outline"
                                    style={{
                                        color: "red",
                                    }}

                                >
                                    {t('library.backstage.DeleteMARC.')}
                                </Button>
                            </Popconfirm>
                            //    ( !readonly &&
                            //     <Button
                            //         className='example'
                            //         style={{ background: '#1565C0', color: '#ffffff' }}
                            //         onClick={e => BibController.exportData({ 'staff_id_arr': selectedRowKeys })}
                            //     >
                            //         匯出資料 <ArrowDownToLine size={16} />
                            //     </Button>),

                        ]
                            : [
                                <Button variant="outline" onClick={() => { window.open("/library/backstage/SearchZ3950", "_blank") }}>
                                    {t('library.backstage.SearchZ3950.')}
                                </Button>,

                            ])
                    }}
                    rowSelection={{
                        type: selectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                />
            </Col>
        </Row>
    )
}


const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`
export default ManageMARCRecord
export { ManageMARCRecordTable }
